const height = {
    /** Medium height call to action buttons and links */
    ctaMedium: 44,
    /** Small height call to action buttons and links */
    ctaSmall: 36,
    /** Extra small height call to action buttons and links */
    ctaXsmall: 24,
    iconMedium: 30,
    iconSmall: 26,
    /** Checkables such as checkboxes or radio buttons */
    iconXsmall: 20,
    /** Text input fields, radio and checkbox labels */
    inputMedium: 44,
    /** Checkables such as checkboxes or radio buttons */
    inputXsmall: 24
};
const iconSize = {
    /** Meets WCAG 2.1 AAA compliance for touch targets. */
    medium: 30,
    small: 26,
    xsmall: 20
};
const size = {
    /** Meets WCAG 2.1 AAA compliance for touch targets. */
    medium: 44,
    small: 36,
    xsmall: 24
};
const width = {
    /** Medium height call to action buttons and links */
    ctaMedium: 44,
    /** Small height call to action buttons and links */
    ctaSmall: 36,
    /** Extra small height call to action buttons and links */
    ctaXsmall: 24,
    iconMedium: 30,
    iconSmall: 26,
    /** Checkables such as checkboxes or radio buttons */
    iconXsmall: 20,
    /** Checkables such as checkboxes or radio buttons */
    inputXsmall: 24
};
const remHeight = {
    /** Medium height call to action buttons and links */
    ctaMedium: "2.75rem",
    /** Small height call to action buttons and links */
    ctaSmall: "2.25rem",
    /** Extra small height call to action buttons and links */
    ctaXsmall: "1.5rem",
    iconMedium: "1.875rem",
    iconSmall: "1.625rem",
    /** Checkables such as checkboxes or radio buttons */
    iconXsmall: "1.25rem",
    /** Text input fields, radio and checkbox labels */
    inputMedium: "2.75rem",
    /** Checkables such as checkboxes or radio buttons */
    inputXsmall: "1.5rem"
};
const remWidth = {
    /** Medium height call to action buttons and links */
    ctaMedium: "2.75rem",
    /** Small height call to action buttons and links */
    ctaSmall: "2.25rem",
    /** Extra small height call to action buttons and links */
    ctaXsmall: "1.5rem",
    iconMedium: "1.875rem",
    iconSmall: "1.625rem",
    /** Checkables such as checkboxes or radio buttons */
    iconXsmall: "1.25rem",
    /** Checkables such as checkboxes or radio buttons */
    inputXsmall: "1.5rem"
};
export { height, iconSize, remHeight, remWidth, size, width };
